import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from './Reveal';
import PartnerCarousel from './PartnerCarousel';
import { ROUTES } from '../routes';

const ArrowRight = () => (
  <svg viewBox="0 0 16 16" width="14" height="14" fill="none" style={{ stroke: 'currentColor', strokeWidth: 1.6 }}>
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const mono: React.CSSProperties = { fontFamily: "'JetBrains Mono', monospace" };

const Hero: React.FC = () => (
  <section
    style={{
      position: 'relative',
      overflow: 'hidden',
      background: 'radial-gradient(125% 95% at 50% 30%, #EFEEE7 0%, var(--bg) 52%, #F1F0E9 78%, var(--bg-alt) 100%)',
      display: 'flex',
      flexDirection: 'column',
      minHeight: 'calc(100dvh - 68px)',
    }}
  >
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: '6rem 1.5rem 3rem',
      }}
    >
      <Reveal
        style={{
          ...mono,
          fontSize: '.6875rem',
          letterSpacing: '.18em',
          textTransform: 'uppercase',
          whiteSpace: 'nowrap',
          color: 'var(--ink-3)',
          marginBottom: '1.6rem',
        }}
      >
        Powered by BTQ Technologies
      </Reveal>

      <Reveal
        as="h1"
        delay={80}
        style={{
          margin: 0,
          maxWidth: '16ch',
          fontWeight: 500,
          fontSize: 'clamp(2.7rem,5.8vw,5rem)',
          lineHeight: 1.02,
          letterSpacing: '-.025em',
          color: 'var(--ink)',
          textWrap: 'balance',
        } as React.CSSProperties}
      >
        The control layer for regulated digital assets.
      </Reveal>

      <Reveal
        as="p"
        delay={140}
        style={{
          margin: '1.9rem 0 0',
          maxWidth: '40rem',
          fontSize: 'clamp(1.0625rem,1.4vw,1.25rem)',
          lineHeight: 1.6,
          color: 'var(--ink-2)',
        }}
      >
        QSSN adds post-quantum authorization to the high-value actions behind stablecoins and tokenized assets — with no chain fork, no re-issuance, and no disruption to customers.
      </Reveal>

      <Reveal delay={200} style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '.75rem', marginTop: '2.5rem' }}>
        <Link
          to={ROUTES.howItWorks}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '.55rem',
            background: 'var(--accent)',
            color: '#fff',
            textDecoration: 'none',
            fontSize: '.9375rem',
            fontWeight: 500,
            padding: '.85rem 1.4rem',
            borderRadius: 9,
            whiteSpace: 'nowrap',
          }}
        >
          See how it works
          <ArrowRight />
        </Link>
        <Link
          to={ROUTES.contact}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '.55rem',
            background: 'transparent',
            color: 'var(--ink)',
            textDecoration: 'none',
            fontSize: '.9375rem',
            fontWeight: 500,
            padding: '.85rem 1.4rem',
            borderRadius: 9,
            border: '1px solid var(--line-strong)',
            whiteSpace: 'nowrap',
          }}
        >
          Talk to us
        </Link>
      </Reveal>
    </div>

    {/* Ecosystem strip pinned to hero bottom */}
    <Reveal style={{ position: 'relative', zIndex: 1, width: '100%' }}>
      <PartnerCarousel compact />
    </Reveal>
  </section>
);

export default Hero;
